import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-customer-message-show",
  templateUrl: "./customer-message-show.component.html",
  styleUrls: ["./customer-message-show.component.css"],
})
export class CustomerMessageShowComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {}

  public accept() {
    this.activeModal.close(true);
  }
  public dismiss() {
    this.activeModal.close(true);
  }
}
